// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1__acbfb7b60d0e0bdeca3f","cls2":"ToolsMenu-cls2__dc410f0882713a3df413 ToolsMenu-cls1__acbfb7b60d0e0bdeca3f"};